<script lang="ts">
	import { trackEvent } from '$lib/utils/mixpanel';
	import { defaults, superForm } from 'sveltekit-superforms';
	import { zod } from 'sveltekit-superforms/adapters';
	import { z } from 'zod';
	import Button from './Button.svelte';
	import Choices from './Choices.svelte';

	interface Props {
		minimumCiInsurance: number;
		sufficientCiInsurance: boolean | undefined;
		currentStep: number;
	}

	let {
		minimumCiInsurance,
		sufficientCiInsurance = $bindable(),
		currentStep = $bindable()
	}: Props = $props();

	const schema = z.object({
		sufficientCiInsurance: z.boolean()
	});

	const { form, enhance, allErrors, validateForm } = superForm(
		defaults(
			{
				sufficientCiInsurance
			},
			zod(schema)
		),
		{
			SPA: true,
			validators: zod(schema),
			dataType: 'json',
			resetForm: false,
			onUpdate({ form }) {
				if (form.valid) {
					sufficientCiInsurance = form.data.sufficientCiInsurance;
					currentStep++;
					trackEvent('Money Habits Tracker - Step 4', {
						sufficientCiInsurance
					});
				}
			}
		}
	);

	validateForm({
		update: true
	});
</script>

<form use:enhance>
	<p class="body-regular mb-6">
		Do you have insurance protection of <span class="h3"
			>S{minimumCiInsurance.toLocaleString('default', {
				style: 'currency',
				currency: 'SGD',
				currencyDisplay: 'narrowSymbol',
				maximumFractionDigits: 0
			})} for critical illness?</span
		>
	</p>
	<Choices bind:choice={$form.sufficientCiInsurance} />

	<Button disabled={$allErrors.length > 0} class="mt-5 w-full">NEXT</Button>
	<Button variant="secondary" class="mt-3 w-full" click={() => currentStep--}>PREVIOUS</Button>
</form>
